import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { useResponsiveBreakpointsVersion } from 'contexts/ResponsiveBreakpointsContext'
import { LoginWrapper } from './Auth.styles'

const LoginVersionMarker = ({ page }) => {
  const version = useResponsiveBreakpointsVersion()

  return (
    <span
      hidden
      data-responsive-breakpoints={version}
      data-responsive-breakpoints-page={page} />
  )
}

LoginVersionMarker.propTypes = {
  page: PropTypes.string.isRequired
}

export const LoginWithRollout = ({
  children,
  page = RESPONSIVE_BREAKPOINT_PAGES.LOGIN
}) => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <LoginWrapper
          className="p-8 text-white"
          aria-live="polite"
          role="status">
          {t('general.loading')}
        </LoginWrapper>
      }
      page={page}>
      <LoginVersionMarker page={page} />
      {children}
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

LoginWithRollout.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string
}

export default LoginWithRollout
